exports.FEATURES = {
  EMERGENCY_MOP_OUTAGE: 'emergency_mop_outage',
  SCHEDULED_ORDERING: 'bts_scheduled_ordering',
  SCHEDULED_ORDERING_GCO: 'scheduled_ordering_gco',
  DEMYSTIFY_MENU_PDP: 'demystify_menu_pdp',
  DEMYSTIFY_PREVIOUS_FAVORITES: 'demystify_previous_favorites',
  DAIBO_EXPERIMENT: 'andre_experiment',
};

exports.VARIATIONS = {
  SHOW_PRICING_ON_MENU_AND_PDP: 'menu_pdp',
  SHOW_PRICING_ON_PDP: 'pdp',
};
